import api from "services/api";
import { reactive } from "vue";
import {
  animal_ai_descriptions_show_url,
  animal_ai_descriptions_save_descriptions_url,
} from "utils/routes";

const state = reactive({
  descriptionsToPublish: [],
  currentAnimalIndex: 0,
  isModalOpen: false,
  isLoading: false,
  isLoadingPublish: false,
  isError: false,
  errorMessage: "",
});

const closeModal = () => {
  state.isModalOpen = false;
  state.isError = false;
  state.errorMessage = "";
};

const loadDescriptions = (batchId) => {
  state.isLoading = true;
  api
    .get(animal_ai_descriptions_show_url(batchId))
    .then((res) => {
      state.descriptionsToPublish = res.data.ai_descriptions;
    })
    .catch((error) => {
      state.isError = true;
      state.errorMessage = error.response.data.message;
    })
    .finally(() => {
      state.isLoading = false;
    });
};

const publishDescriptions = (batchId) => {
  state.isLoadingPublish = true;
  api
    .post(animal_ai_descriptions_save_descriptions_url(batchId), {
      descriptions: state.descriptionsToPublish,
    })
    .then((res) => {
      closeModal();
      location.reload();
    })
    .catch((error) => {
      state.isError = true;
      state.errorMessage = error.response.data.message;
    })
    .finally(() => {
      state.isLoadingPublish = false;
    });
};

export { state, closeModal, loadDescriptions, publishDescriptions };
